import React from 'react';
import { LayoutTitle } from '../Layout';
import { formatMoney } from '../../../../common/utils';
export function Review({ fields }) {
    var _a, _b, _c, _d, _e, _f;
    const planPrice = parseFloat(((_a = fields.selectedPlan) === null || _a === void 0 ? void 0 : _a.price) || '0');
    return (React.createElement("div", { className: 'register-review' },
        React.createElement(LayoutTitle, { text: "Your Plan" }),
        React.createElement("div", { className: 'review-table-wrapper' },
            React.createElement("table", null,
                React.createElement("thead", null,
                    React.createElement("tr", null,
                        React.createElement("th", null,
                            "Tracknotion Package Plan: ",
                            React.createElement("span", null, (_b = fields.selectedPlan) === null || _b === void 0 ? void 0 : _b.name)),
                        React.createElement("th", null),
                        React.createElement("th", null, "Price"))),
                React.createElement("tbody", null,
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            "Local Numbers ",
                            React.createElement("strong", null,
                                "(", (_c = fields.selectedPlan) === null || _c === void 0 ? void 0 :
                                _c.total_local_numbers,
                                ")")),
                        React.createElement("td", null),
                        React.createElement("td", null,
                            React.createElement("strong", null,
                                formatMoney(planPrice),
                                "/month"))),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            "Toll-Free Numbers ",
                            React.createElement("strong", null,
                                "(", (_d = fields.selectedPlan) === null || _d === void 0 ? void 0 :
                                _d.total_tollfree_numbers,
                                ")")),
                        React.createElement("td", null),
                        React.createElement("td", null)),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            "Local Minutes included ",
                            React.createElement("strong", null,
                                "(", (_e = fields.selectedPlan) === null || _e === void 0 ? void 0 :
                                _e.total_local_minutes,
                                ")")),
                        React.createElement("td", null),
                        React.createElement("td", null)),
                    React.createElement("tr", null,
                        React.createElement("td", null,
                            "Toll-Free Minutes included ",
                            React.createElement("strong", null,
                                "(", (_f = fields.selectedPlan) === null || _f === void 0 ? void 0 :
                                _f.total_tollfree_minutes,
                                ")")),
                        React.createElement("td", null),
                        React.createElement("td", null)),
                    React.createElement("tr", { className: 'review-table__footer' },
                        React.createElement("td", null),
                        React.createElement("td", null),
                        React.createElement("td", { className: 'final-price__wrapper' },
                            React.createElement("span", null, "Due Today: "),
                            React.createElement("div", { className: 'final-price' }, formatMoney(planPrice)))))))));
}
